import { render, staticRenderFns } from "./ProjectValuationScoreIndustryTable.vue?vue&type=template&id=37ad2234&scoped=true&"
import script from "./ProjectValuationScoreIndustryTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreIndustryTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScoreIndustryTable.vue?vue&type=style&index=0&id=37ad2234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad2234",
  null
  
)

export default component.exports